import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { ViewVehicleDetailsService } from "./view-vehicle-details.service";

@Component({
  selector: "app-view-vehicle-details",
  templateUrl: "./view-vehicle-details.component.html",
  styleUrls: ["./view-vehicle-details.component.sass"],
})
export class ViewVehicleDetailsComponent implements OnInit {
  vehicleId: any;
  vehicleDetail: any;
  isRangeVisible: boolean = false;
  isGInfoVisible: boolean = true;
  constructor(
    public activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private viewVehicleService: ViewVehicleDetailsService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.vehicleId = this.activatedRoute.snapshot.queryParams.id;
    // console.log(this.vehicleId)
    this.getVehicleById();
  }

  getVehicleById() {
    let data = {
      id: this.vehicleId,
    };
    this.spinner.show();
    this.viewVehicleService.getVehicleById(data).subscribe((result: any) => {
      console.log(result);
      if (result.statusCode == 200) {
        this.spinner.hide();
        this.vehicleDetail = result.data;
      } else {
        this.spinner.hide();
        this.toastr.error(result.message);
      }
    });
  }
  generalInfoVisible() {
    this.isRangeVisible = false;
    this.isGInfoVisible = true;
  }
  rangeVisibility() {
    this.isRangeVisible = true;
    this.isGInfoVisible = false;
  }

  back() {
    this.router.navigateByUrl("dashboard/vehicle");
  }

  imageUrl: any;
  insuranceImageUrl: any;
  rcImageUrl: any;
  roadTaxImageurl: any;
  onNavigate(image_name, imagePath) {
    if (image_name == "IMAGE") {
      if (imagePath != "" && imagePath != null) {
        this.imageUrl = imagePath;
      } else {
        this.imageUrl = "";
        this.toastr.error("Image Not Found");
      }
    } else if (image_name == "INSURANCE") {
      if (imagePath != "" && imagePath != null) {
        this.insuranceImageUrl = imagePath;
      } else {
        this.insuranceImageUrl = "";
        this.toastr.error("Image Not Found");
      }
    } else if (image_name == "RC") {
      if (imagePath != "" && imagePath != null) {
        this.rcImageUrl = imagePath;
      } else {
        this.rcImageUrl = "";
        this.toastr.error("Image Not Found");
      }
    } else if (image_name == "ROADTAX") {
      if (imagePath != "" && imagePath != null) {
        this.roadTaxImageurl = imagePath;
      } else {
        this.roadTaxImageurl = "";
        this.toastr.error("Image Not Found");
      }
    }
  }
}
